import React from 'react'
import { ListItem } from 'material-ui/List'
import Divider from 'material-ui/Divider'
import Avatar from 'material-ui/Avatar'

const avatar = (activity) => {
  if (activity.mission) {
    return activity.mission.image_url
  } else if (activity.medal) {
    return activity.medal.image_url
  } else if (activity.campaign) {
    return activity.campaign.image_url
  } else if (activity.title) {
    return activity.title.image_url
  }
  return null
}

const name = activity => `${activity.user.first_name} ${activity.user.last_name}`

const text = (activity) => {
  if (activity.mission) {
    return `Ha completado con éxito la misión ${activity.mission.name}.`
  } else if (activity.medal) {
    return `Ha ganado la medalla ${activity.medal.name}.`
  } else if (activity.campaign) {
    return null
  } else if (activity.title) {
    return `Ha ganado el título ${activity.title.name}.`
  }
  return null
}

const Activity = (activity,toggleOpen,toggleDialog) => (
  <div key={activity.id}
    onTouchTap={() => toggleDialog(activity,toggleOpen)}>
    <Divider />
    <ListItem
      leftAvatar={<Avatar src={avatar(activity)} />}
      primaryText={name(activity)}
      secondaryText={
        <p>
          {text(activity)}
        </p>
        }
    />
  </div>
)

export default Activity



// WEBPACK FOOTER //
// ./src/components/Main/Activities/Activity/index.jsx